












































import Component, { mixins } from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import ScrollView from '@/components/ScrollView.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { AgingFilterFormsMixin } from '@/views/app/management/collections/components/GlobalAging/AgingFilterFormsMixin'
import { Debounce } from 'vue-debounce-decorator'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'
import { IPayerType } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: { LoaderWrapper, Checkbox, ScrollView, SearchInput },
  props: {
    facilities: {
      type: Array
    }
  }
})
export default class PayersFilterForm extends mixins(AgingFilterFormsMixin) {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  localOptions: any = {}

  get selectedPayers () {
    return this.filtersMap['payers']
  }

  mounted () {
    this.fetch()
  }

  @Debounce(800)
  async fetchData () {
    await this.fetch()
  }

  async fetch () {
    try {
      this.isLoading = true
      const payload: any = {
        payerName: this.searchValue.trim(),
        facilityIds: this.$props.facilities
      }
      const { payerTypes } = await this.facilityModuleInstance.getAllFacilitiesPayerTypes(payload)
      if (payerTypes && payerTypes.length) {
        payerTypes.sort((x: IPayerType, y: IPayerType) =>
          // @ts-ignore
          Number(this.isChecked('payers', y.id.toString())) - Number(this.isChecked('payers', x.id.toString())))

        this.localOptions = payerTypes.map((payerType: IPayerType) => ({
            value: payerType.id as number,
            label: `${payerType.payer_name ? payerType.payer_name : ''}`
        }))
      }
    } finally {
      this.isLoading = false
      if (this.focusEl) {
        setTimeout(() => this.focusEl.focus(), 50)
      }
    }
  }
}
